import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { authHttpInterceptorFn, provideAuth0 } from '@auth0/auth0-angular';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { UpgradeModule } from '@angular/upgrade/static';
import { provideSentinelService, withNewRelic } from '@bannerflow/sentinel';
import { provideFeatureFlags } from './core/unleash/feature-flag.providers';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideFeatureFlags({
            enabled: environment.featureFlags.enabled,
            appName: 'B2Frontend',
            clientKey: environment.featureFlags.clientKey,
            url: environment.featureFlags.url,
            refreshInterval: 30
        }),
        provideAuth0({
            domain: environment.LOGIN_URL,
            clientId: environment.CLIENT_ID,
            authorizationParams: {
                redirect_uri: `${window.location.origin}/${window.location.search}`,
                audience: 'https://bannerflow.com/resources/',
                scope: 'openid profile email offline_access bannerflow'
            },
            httpInterceptor: {
                allowedList: [environment.API_URLS].map(url => `${url}/*`)
            },
            useRefreshTokens: true,
            cacheLocation: 'localstorage'
        }),
        provideSentinelService(
            withNewRelic({
                ...environment.newRelic,
                applicationVersion: environment.version,
                releaseName: environment.version,
                releaseId: environment.version,
                sessionReplay: {
                    enabled: false,
                    fixCss: false
                }
            })
        ),
        provideHttpClient(withXhr(), withInterceptors([authHttpInterceptorFn])),
        provideAnimationsAsync(), // Needed for @bannerflow/ui
        importProvidersFrom(UpgradeModule)
    ]
};
